import React, { useState } from 'react';
import { X, Upload, FileText, File, Image, FolderPlus, Tag, Calendar, Users, AlertCircle, Check, ChevronDown } from 'lucide-react';
export const DocumentUploadModal = ({
  isOpen,
  onClose,
  activeDepartment
}) => {
  const [uploadType, setUploadType] = useState('file');
  const [documentName, setDocumentName] = useState('');
  const [documentType, setDocumentType] = useState('PDF');
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedTags, setSelectedTags] = useState([]);
  const [showDropzone, setShowDropzone] = useState(true);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  if (!isOpen) return null;
  const handleFileChange = e => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setDocumentName(file.name);
      setShowDropzone(false);
      // Simulate determining file type
      if (file.type.includes('pdf')) {
        setDocumentType('PDF');
      } else if (file.type.includes('image')) {
        setDocumentType('Image');
      } else {
        setDocumentType('Document');
      }
    }
  };
  const handleDrop = e => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      setSelectedFile(file);
      setDocumentName(file.name);
      setShowDropzone(false);
      // Simulate determining file type
      if (file.type.includes('pdf')) {
        setDocumentType('PDF');
      } else if (file.type.includes('image')) {
        setDocumentType('Image');
      } else {
        setDocumentType('Document');
      }
    }
  };
  const handleDragOver = e => {
    e.preventDefault();
  };
  const handleUpload = () => {
    if (!selectedFile && uploadType === 'file') return;
    if (!documentName) return;
    setIsUploading(true);
    // Simulate upload progress
    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      setUploadProgress(progress);
      if (progress >= 100) {
        clearInterval(interval);
        // Simulate some processing time at 100%
        setTimeout(() => {
          onClose();
        }, 500);
      }
    }, 300);
  };
  const handleAddTag = tag => {
    if (!selectedTags.includes(tag)) {
      setSelectedTags([...selectedTags, tag]);
    }
  };
  const handleRemoveTag = tag => {
    setSelectedTags(selectedTags.filter(t => t !== tag));
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center" data-id="element-295">
      <div className="bg-white w-full max-w-3xl rounded-lg shadow-xl overflow-hidden" data-id="element-296">
        <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between" data-id="element-297">
          <h2 className="text-lg font-semibold text-gray-800" data-id="element-298">
            {uploadType === 'file' ? 'Upload New Document' : 'Create New Folder'}
          </h2>
          <button className="text-gray-500 hover:text-gray-700" onClick={onClose} data-id="element-299">
            <X className="h-5 w-5" data-id="element-300" />
          </button>
        </div>
        <div className="p-6" data-id="element-301">
          <div className="flex space-x-4 mb-6" data-id="element-302">
            <button className={`flex-1 py-2 px-4 rounded-md text-center ${uploadType === 'file' ? 'bg-blue-100 text-blue-700 font-medium' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setUploadType('file')} data-id="element-303">
              Upload File
            </button>
            <button className={`flex-1 py-2 px-4 rounded-md text-center ${uploadType === 'folder' ? 'bg-blue-100 text-blue-700 font-medium' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setUploadType('folder')} data-id="element-304">
              Create Folder
            </button>
          </div>
          {uploadType === 'file' && <>
              {showDropzone ? <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center mb-6" onDrop={handleDrop} onDragOver={handleDragOver} data-id="element-305">
                  <Upload className="h-10 w-10 text-gray-400 mx-auto mb-3" data-id="element-306" />
                  <p className="text-gray-600 mb-2" data-id="element-307">
                    Drag and drop your file here, or
                  </p>
                  <label className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors cursor-pointer inline-block" data-id="element-308">
                    Browse Files
                    <input type="file" className="hidden" onChange={handleFileChange} data-id="element-309" />
                  </label>
                  <p className="text-xs text-gray-500 mt-2" data-id="element-310">
                    Supported file types: PDF, DOCX, XLSX, JPG, PNG
                  </p>
                </div> : <div className="bg-gray-50 rounded-lg p-4 mb-6" data-id="element-311">
                  <div className="flex items-center" data-id="element-312">
                    <div className="h-12 w-12 bg-blue-100 rounded-md flex items-center justify-center mr-4" data-id="element-313">
                      {documentType === 'PDF' ? <FileText className="h-6 w-6 text-blue-600" data-id="element-314" /> : documentType === 'Image' ? <Image className="h-6 w-6 text-blue-600" data-id="element-315" /> : <File className="h-6 w-6 text-blue-600" data-id="element-316" />}
                    </div>
                    <div className="flex-1" data-id="element-317">
                      <p className="text-sm font-medium text-gray-800" data-id="element-318">
                        {selectedFile?.name}
                      </p>
                      <p className="text-xs text-gray-500 mt-1" data-id="element-319">
                        {documentType} • {formatFileSize(selectedFile?.size)}
                      </p>
                    </div>
                    <button className="text-gray-500 hover:text-gray-700" onClick={() => {
                setSelectedFile(null);
                setShowDropzone(true);
              }} data-id="element-320">
                      <X className="h-5 w-5" data-id="element-321" />
                    </button>
                  </div>
                </div>}
            </>}
          <div className="space-y-4" data-id="element-322">
            <div data-id="element-323">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-324">
                {uploadType === 'file' ? 'Document Name' : 'Folder Name'}*
              </label>
              <input type="text" className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder={uploadType === 'file' ? 'Enter document name' : 'Enter folder name'} value={documentName} onChange={e => setDocumentName(e.target.value)} data-id="element-325" />
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-326">
              <div data-id="element-327">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-328">
                  Department
                </label>
                <select className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" defaultValue={activeDepartment} data-id="element-329">
                  <option value="General Manager Office" data-id="element-330">
                    General Manager Office
                  </option>
                  <option value="Finance Department" data-id="element-331">Finance Department</option>
                  <option value="HR Department" data-id="element-332">HR Department</option>
                  <option value="IT Department" data-id="element-333">IT Department</option>
                  <option value="Legal Department" data-id="element-334">Legal Department</option>
                  <option value="Audit Department" data-id="element-335">Audit Department</option>
                </select>
              </div>
              {uploadType === 'file' && <div data-id="element-336">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-337">
                    Document Type
                  </label>
                  <select className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" value={documentType} onChange={e => setDocumentType(e.target.value)} data-id="element-338">
                    <option value="PDF" data-id="element-339">PDF</option>
                    <option value="Document" data-id="element-340">Document</option>
                    <option value="Image" data-id="element-341">Image</option>
                    <option value="Spreadsheet" data-id="element-342">Spreadsheet</option>
                    <option value="Presentation" data-id="element-343">Presentation</option>
                  </select>
                </div>}
            </div>
            <div data-id="element-344">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-345">
                Tags
              </label>
              <div className="flex flex-wrap gap-2 mb-2" data-id="element-346">
                {selectedTags.map((tag, index) => <div key={index} className="bg-blue-100 text-blue-800 text-xs rounded-full px-3 py-1 flex items-center" data-id="element-347">
                    <span data-id="element-348">{tag}</span>
                    <button className="ml-1 text-blue-600 hover:text-blue-800" onClick={() => handleRemoveTag(tag)} data-id="element-349">
                      <X className="h-3 w-3" data-id="element-350" />
                    </button>
                  </div>)}
              </div>
              <div className="flex space-x-2" data-id="element-351">
                <input type="text" className="flex-1 border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Add a tag" onKeyDown={e => {
                if (e.key === 'Enter' && e.target.value.trim()) {
                  handleAddTag(e.target.value.trim());
                  e.target.value = '';
                }
              }} data-id="element-352" />
                <div className="relative" data-id="element-353">
                  <button className="px-3 py-2 border border-gray-300 rounded-md text-gray-700 flex items-center space-x-1" data-id="element-354">
                    <span data-id="element-355">Common Tags</span>
                    <ChevronDown className="h-4 w-4" data-id="element-356" />
                  </button>
                  <div className="absolute right-0 mt-1 w-48 bg-white rounded-md shadow-lg border border-gray-200 z-10 hidden" data-id="element-357">
                    <div className="py-1" data-id="element-358">
                      {['Report', 'Finance', '2023', 'Contract', 'HR', 'Confidential'].map(tag => <button key={tag} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" onClick={() => handleAddTag(tag)} data-id="element-359">
                          {tag}
                        </button>)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-360">
              <div data-id="element-361">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-362">
                  Access Level
                </label>
                <select className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" defaultValue="department" data-id="element-363">
                  <option value="private" data-id="element-364">Private (Only Me)</option>
                  <option value="department" data-id="element-365">Department</option>
                  <option value="organization" data-id="element-366">Entire Organization</option>
                  <option value="custom" data-id="element-367">Custom...</option>
                </select>
              </div>
              <div data-id="element-368">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-369">
                  Retention Policy
                </label>
                <select className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" defaultValue="default" data-id="element-370">
                  <option value="default" data-id="element-371">Default (7 years)</option>
                  <option value="1year" data-id="element-372">1 Year</option>
                  <option value="3years" data-id="element-373">3 Years</option>
                  <option value="5years" data-id="element-374">5 Years</option>
                  <option value="10years" data-id="element-375">10 Years</option>
                  <option value="permanent" data-id="element-376">Permanent</option>
                </select>
              </div>
            </div>
            <div data-id="element-377">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-378">
                Description
              </label>
              <textarea className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 h-20" placeholder="Add a description..." data-id="element-379"></textarea>
            </div>
            <div className="flex items-center" data-id="element-380">
              <input type="checkbox" id="start_workflow" className="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500" data-id="element-381" />
              <label htmlFor="start_workflow" className="ml-2 text-sm text-gray-700" data-id="element-382">
                Start a workflow for this document
              </label>
            </div>
          </div>
          {isUploading && <div className="mt-6" data-id="element-383">
              <div className="flex justify-between items-center mb-1" data-id="element-384">
                <span className="text-sm text-gray-600" data-id="element-385">Uploading...</span>
                <span className="text-sm text-gray-600" data-id="element-386">{uploadProgress}%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-387">
                <div className="bg-blue-600 h-2 rounded-full" style={{
              width: `${uploadProgress}%`
            }} data-id="element-388"></div>
              </div>
            </div>}
        </div>
        <div className="px-6 py-4 border-t border-gray-200 flex justify-between" data-id="element-389">
          <button className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors" onClick={onClose} data-id="element-390">
            Cancel
          </button>
          <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors flex items-center space-x-2" onClick={handleUpload} disabled={isUploading || !selectedFile && uploadType === 'file' || !documentName} data-id="element-391">
            {isUploading ? <>
                <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full" data-id="element-392"></div>
                <span data-id="element-393">Uploading...</span>
              </> : <>
                {uploadType === 'file' ? <>
                    <Upload className="h-4 w-4" data-id="element-394" />
                    <span data-id="element-395">Upload Document</span>
                  </> : <>
                    <FolderPlus className="h-4 w-4" data-id="element-396" />
                    <span data-id="element-397">Create Folder</span>
                  </>}
              </>}
          </button>
        </div>
      </div>
    </div>;
};
// Helper function to format file size
const formatFileSize = bytes => {
  if (!bytes) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};